/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-plusplus */
import { IoEye, IoShareSocial } from "react-icons/io5";
import { useEffect, useState } from "react";
import { Popover, Skeleton } from "@mui/material";
import { LiaDownloadSolid } from "react-icons/lia";

import { FaArrowLeft, FaFilePdf } from "react-icons/fa";
import { useFiltrarViasPV } from "services/api/AppWeb_PropostaVendas/filtrar-vias-vp";

import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { MdKeyboardArrowRight } from "react-icons/md";
import { RiUserLine } from "react-icons/ri";

import ModalCommon from "components/ModalCommon";
import SelectComponent from "components/SelectG";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { CgArrowsExchangeAltV } from "react-icons/cg";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useHistory } from "react-router-dom";
import { FaRegFileLines } from "react-icons/fa6";
import { RiFileExcel2Fill } from "react-icons/ri";
import { CARGO_CODES } from "constants/permissions";
import * as S from "./styles";

import MaterialUI from "../../../../material-UI";
import TableProduct from "./components/tableProduct";
import ModalAprovacao from "./components/modalAprovacao";
import ModalEntradaProcesso from "./components/modalEntradaProcesso";

import { ModalResultadoAnalise } from "./components/modalResultadoAnalise";
import { ContainerChecklist } from "./components/containerChecklist";
import ModalAnexarLaudoVivaz from "./components/modalAnexarLaudoVivaz";
import ModalComprovanteAto from "./components/modalComprovanteAto";
import { ModalTransferirProposta } from "./components/modalTransferirProposta";
import { ModalCompartilhar } from "./components/modalCompartilhar";
import { ModalVincular } from "./components/modalVincular";
import ModalSolicitarAjuste from "./components/modalSolicitarAjuste";

const dataViasPV = [
  { label: "1ª via com comissão", value: 1 },
  { label: "1ª via sem comissão", value: 2 },
  { label: "2ª via menor", value: 3 },
  { label: "3ª via cliente", value: 4 },
  { label: "4ª via cliente simplificada", value: 5 },
  // { label: "5ª via Wacc", value: 6 },
  // { label: "6ª via CDI", value: 7 },
];

const dataViasPVComercial = [
  { label: "1ª via sem comissão", value: 2 },
  { label: "5ª via", value: 6 },
];

interface Data {
  params: any;
  dataDetalheOportunidade?: any;
  refetchDetalheOportunidade?: any;
  refetchHistorico?: any;
  isLoading?: boolean;
  funnelBackPath?: string;
  navigationState?: { from?: string };
}

export function PropostaCard(data: Data) {
  const history = useHistory();
  const { usuarioComercial, codigoCargo2013, usuarioVivaz } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const cargoCorretor = codigoCargo2013 === "219.840.002";
  const usuarioGerenteComercial =
    codigoCargo2013 === CARGO_CODES.GERENTE_COMERCIAL;
  const isGerenteComercialVivaz = usuarioGerenteComercial && usuarioVivaz;
  const [dataVias, setDataVias] = useState<any>(null);
  const [dataViasList] = useState<any[]>(
    usuarioComercial ? dataViasPVComercial : dataViasPV
  );
  const [documento, setDocumento] = useState<any | null>(null);
  const [openModalAprovacao, setOpenModalAprovacao] = useState(false);
  const [openModalEntradaProcesso, setOpenModalEntradaProcesso] =
    useState(false);
  const [openModalLaudo, setOpenModalLaudo] = useState(false);
  const [openModalComprovanteAto, setOpenModalComprovanteAto] = useState(false);
  const [openModalResultadoAnalise, setOpenModalResultadoAnalise] =
    useState(false);
  const [openModalSolicitarAjuste, setOpenModalSolicitarAjuste] =
    useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopOver = Boolean(anchorEl);
  const [openModalTransferirProposta, setOpenModalTransferirProposta] =
    useState(false);
  const [openModalCompartilhar, setOpenModalCompartilhar] = useState(false);
  const [openModalVincular, setOpenModalVincular] = useState(false);
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleClickPopover = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const mutateVias = useFiltrarViasPV({
    numeroCotacao: data.params?.numeroCotacao,
    tipoDocumento: dataVias?.value,
  });

  const downloadDocumento = () => {
    if (!documento) {
      console.error("Documento é null");
      return;
    }

    const { base64 } = documento;
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: documento?.tipoExtensao });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = documento.nome;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const viewDocumento = () => {
    if (!documento) {
      console.error("Documento é null");
      return;
    }

    const { base64 } = documento;
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: documento.tipoExtensao });
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank");
  };

  const handleGenerate = () => {
    setDocumento(null);
    mutateVias.mutate();
  };

  useEffect(() => {
    const dataAtual = format(new Date(), "dd-MM-yyyy_HH-mm-ss", {
      locale: ptBR,
    });
    if (mutateVias.isSuccess) {
      setDocumento({
        tipoExtensao: mutateVias?.data?.data?.documento?.tipoExtensao,
        base64: mutateVias?.data?.data?.documento?.base64,
        nome: `documento_${dataAtual}`,
      });
    }
  }, [mutateVias.isSuccess]);

  const downloadLaudo = () => {
    const url = data.dataDetalheOportunidade?.urlLaudoCredito;
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = url?.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const viewLaudo = () => {
    const url = data.dataDetalheOportunidade?.urlLaudoCredito;
    if (!url) return;
    window.open(url, "_blank");
  };

  function viewProposta() {
    const url = data?.dataDetalheOportunidade?.urlPropostaPdf;
    if (!url) return;

    const googleDocsViewer = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
      url
    )}`;
    window.open(googleDocsViewer, "_blank");
  }

  function downloadProposta() {
    const url = data?.dataDetalheOportunidade?.urlPropostaPdf;
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.download = url?.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function downloadPropostaExcel() {
    const url = data?.dataDetalheOportunidade?.urlPropostaExcel;
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.download = url?.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const truncateMiddleWithExtension = (filename: any, maxLength: any) => {
    if (!filename) return "";
    if (filename.length <= maxLength) return filename;

    const parts = filename.split(".");
    const extension = parts.length > 1 ? `.${parts.pop()}` : "";
    const nameWithoutExtension = parts.join(".");

    const charsToShow = maxLength - extension.length - 3;
    if (charsToShow <= 0) return `...${extension}`;

    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return `${nameWithoutExtension.substr(
      0,
      frontChars
    )}...${nameWithoutExtension.substr(
      nameWithoutExtension.length - backChars
    )}${extension}`;
  };

  return (
    <>
      <S.Container>
        {data?.isLoading ? (
          <Skeleton variant="rounded" width="100%" height="100%" />
        ) : (
          <>
            <S.Row style={{ width: "100%", justifyContent: "center" }}>
              <S.TitleHeader>PROPOSTA</S.TitleHeader>
            </S.Row>
            <S.Line />
            <TableProduct
              dataDetalheOportunidade={data?.dataDetalheOportunidade}
            />
            {data?.dataDetalheOportunidade?.pendencias?.length > 0
              ? data?.dataDetalheOportunidade?.pendencias?.map(
                  (pendencia: any) => (
                    <ContainerChecklist
                      titulo={pendencia?.titulo}
                      observacao={pendencia?.observacao}
                      nome={pendencia?.nome}
                      url={pendencia?.url}
                      extensao={pendencia?.extensao}
                      codigoEtapa={pendencia?.codigoEtapa}
                      dataDetalheOportunidade={data?.dataDetalheOportunidade}
                      refetchDetalheOportunidade={
                        data?.refetchDetalheOportunidade
                      }
                      refetchHistorico={data?.refetchHistorico}
                    />
                  )
                )
              : null}
            {data?.dataDetalheOportunidade?.resultadoAnalise?.alerta ? (
              <S.ContainerMessage
                backgroundColor={
                  data?.dataDetalheOportunidade?.resultadoAnalise?.alerta?.cor
                    ?.fundo
                }
              >
                <S.TextMessage
                  color={
                    data?.dataDetalheOportunidade?.resultadoAnalise?.alerta?.cor
                      ?.texto
                  }
                >
                  {
                    data?.dataDetalheOportunidade?.resultadoAnalise?.alerta
                      ?.titulo
                  }
                </S.TextMessage>
                <S.SubTextMessage
                  color={
                    data?.dataDetalheOportunidade?.resultadoAnalise?.alerta?.cor
                      ?.texto
                  }
                >
                  {
                    data?.dataDetalheOportunidade?.resultadoAnalise?.alerta
                      ?.mensagem
                  }
                </S.SubTextMessage>
              </S.ContainerMessage>
            ) : null}
            {data?.dataDetalheOportunidade?.responsavelAnaliseAtual ? (
              <S.Row style={{ marginTop: 16 }}>
                <S.ResponsavelBadge>
                  <RiUserLine size={16} color="#2D5BFF" />
                  <S.ResponsavelBadgeText>
                    RESP.:{" "}
                    {data?.dataDetalheOportunidade?.responsavelAnaliseAtual}
                  </S.ResponsavelBadgeText>
                </S.ResponsavelBadge>
              </S.Row>
            ) : null}
            {/* Primeira linha - Botões de simulação e ações */}
            <S.Row
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 16,
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <S.Row style={{ gap: 12, flexWrap: "wrap" }}>
                {data.dataDetalheOportunidade?.editarSimulacaoVisivel &&
                !data.dataDetalheOportunidade?.ajustarProposta ? (
                  <S.ButtonBordered
                    onClick={() => {
                      if (data.dataDetalheOportunidade?.repasseAssociativo) {
                        window.location.href = `/lead-detail/${data.params.idLeadCorretor}/repasse-associativo/${data.dataDetalheOportunidade.unidadeId}/${data.dataDetalheOportunidade.idOportunidade}/${data.params.numeroCotacao}/editable`;
                      } else {
                        history.push(
                          `/lead-detail/${data.params.idLeadCorretor}/${data.dataDetalheOportunidade.idLead365}/proposition-detail/${data.params.numeroCotacao}/${data.dataDetalheOportunidade.idOportunidade}`,
                          data.navigationState
                        );
                      }
                      setDataVias(null);
                    }}
                    width="130px"
                    height="36px"
                    border={"1px solid #2D5BFF"}
                    color={"#FFFFFF"}
                  >
                    <S.TextButton color={"#2D5BFF"}>
                      Editar Simulação
                    </S.TextButton>
                  </S.ButtonBordered>
                ) : null}

                {!data.dataDetalheOportunidade?.editarSimulacaoVisivel &&
                !data.dataDetalheOportunidade?.ajustarProposta ? (
                  <S.ButtonBordered
                    onClick={() => {
                      if (data.dataDetalheOportunidade?.repasseAssociativo) {
                        window.location.href = `/lead-detail/${data.params.idLeadCorretor}/repasse-associativo/${data.dataDetalheOportunidade.unidadeId}/${data.dataDetalheOportunidade.idOportunidade}/${data.params.numeroCotacao}/editable`;
                      } else {
                        history.push(
                          `/lead-detail/${data.params.idLeadCorretor}/${data.dataDetalheOportunidade.idLead365}/proposition-detail/${data.params.numeroCotacao}/${data.dataDetalheOportunidade.idOportunidade}`,
                          data.navigationState
                        );
                      }
                      setDataVias(null);
                    }}
                    width="120px"
                    height="36px"
                    border={"1px solid #2D5BFF"}
                    color={"#FFFFFF"}
                  >
                    <S.TextButton color={"#2D5BFF"}>Ver Simulação</S.TextButton>
                  </S.ButtonBordered>
                ) : null}

                {!data.dataDetalheOportunidade?.editarSimulacaoVisivel &&
                data.dataDetalheOportunidade?.ajustarProposta ? (
                  <S.ButtonBordered
                    onClick={() => {
                      if (data.dataDetalheOportunidade?.repasseAssociativo) {
                        window.location.href = `/lead-detail/${data.params.idLeadCorretor}/repasse-associativo/${data.dataDetalheOportunidade.unidadeId}/${data.dataDetalheOportunidade.idOportunidade}/${data.params.numeroCotacao}/editable`;
                      } else {
                        history.push(
                          `/lead-detail/${data.params.idLeadCorretor}/${data.dataDetalheOportunidade.idLead365}/proposition-detail/${data.params.numeroCotacao}/${data.dataDetalheOportunidade.idOportunidade}`,
                          data.navigationState
                        );
                      }
                      setDataVias(null);
                    }}
                    width="120px"
                    height="36px"
                    border={"1px solid #2D5BFF"}
                    color={"#FFFFFF"}
                  >
                    <S.TextButton color={"#2D5BFF"}>
                      Ajustar Proposta
                    </S.TextButton>
                  </S.ButtonBordered>
                ) : null}

                {data.dataDetalheOportunidade?.repasseAssociativo === true ? (
                  <>
                    <S.Button
                      width="36px"
                      height="36px"
                      color="#EAEFFF"
                      onClick={handleClickPopover}
                    >
                      <S.TextButton color={"#2D5BFF"}>
                        <FaFilePdf size={16} />
                      </S.TextButton>
                    </S.Button>
                    <Popover
                      open={openPopOver}
                      anchorEl={anchorEl}
                      onClose={handleClosePopover}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <S.ContainerPopover>
                        <S.Button width="40px" height="40px" color="#EAEFFF">
                          <S.TextButton
                            color="#2D5BFF"
                            onClick={() => viewProposta()}
                          >
                            Visualizar Simulação
                          </S.TextButton>
                        </S.Button>
                        <S.Button width="40px" height="40px" color="#EAEFFF">
                          <S.TextButton onClick={() => downloadProposta()}>
                            Baixar Simulação
                          </S.TextButton>
                        </S.Button>
                      </S.ContainerPopover>
                    </Popover>
                  </>
                ) : null}

                {/* {data.dataDetalheOportunidade?.repasseAssociativo === true &&
                codigoCargo2013 === "219.840.002" ? (
                  data.dataDetalheOportunidade?.urlLaudoCredito !== null ? (
                    <S.FieldFilled width="160px" height="36px" color="#FFFFFF">
                      <IoIosCheckmarkCircle
                        size={16}
                        color="#4CAF50"
                        className="icon-default"
                      />
                      <S.TextFilledButton
                        color="#646363"
                        className="text-default"
                        style={{ fontSize: "11px" }}
                      >
                        {truncateMiddleWithExtension(
                          data.dataDetalheOportunidade?.urlLaudoCredito
                            ?.split("/")
                            .pop(),
                          14
                        )}
                      </S.TextFilledButton>
                      <div className="hover-buttons">
                        <S.ButtonFilled onClick={viewLaudo}>
                          <IoEye size={18} color="#2D5BFF" />
                        </S.ButtonFilled>
                        <S.ButtonFilled onClick={downloadLaudo}>
                          <LiaDownloadSolid size={18} color="#2D5BFF" />
                        </S.ButtonFilled>
                        <S.ButtonFilled onClick={() => setOpenModalLaudo(true)}>
                          <CgArrowsExchangeAltV size={18} color="#2D5BFF" />
                        </S.ButtonFilled>
                      </div>
                    </S.FieldFilled>
                  ) : (
                    <S.Button
                      onClick={() => setOpenModalLaudo(true)}
                      width="120px"
                      height="36px"
                      color="#EAEFFF"
                    >
                      <S.TextButton color="#2D5BFF">Anexar Laudo</S.TextButton>
                    </S.Button>
                  )
                ) : null} */}

                {/* Botões de ação na mesma linha */}

                {data?.dataDetalheOportunidade?.habilitarTransferencia ? (
                  <S.Button
                    width="100px"
                    style={{ display: "flex", alignItems: "center" }}
                    height="36px"
                    color="#EAEFFF"
                    onClick={() => {
                      setOpenModalTransferirProposta(true);
                    }}
                  >
                    <S.TextButton color="#2D5BFF">
                      Transferir
                      <MdKeyboardArrowRight size={18} color="#2D5BFF" />
                    </S.TextButton>
                  </S.Button>
                ) : null}

                {data?.dataDetalheOportunidade?.podeCompartilhar ? (
                  <S.Button
                    onClick={() => {
                      setOpenModalCompartilhar(true);
                    }}
                    width="120px"
                    height="36px"
                    color="#2D5BFF"
                  >
                    <S.TextButton color="#EAEFFF" style={{ gap: "6px" }}>
                      Compartilhar <IoShareSocial size={14} />
                    </S.TextButton>
                  </S.Button>
                ) : null}

                {data?.dataDetalheOportunidade?.pendenteAnalise ? (
                  <S.Button
                    onClick={() => setOpenModalResultadoAnalise(true)}
                    width="140px"
                    height="36px"
                    color="#EAEFFF"
                  >
                    <S.TextButton color="#2D5BFF">
                      Resultado da Análise
                      <MdKeyboardArrowRight size={18} color="#2D5BFF" />
                    </S.TextButton>
                  </S.Button>
                ) : null}
              </S.Row>

              {/* Container PV - lado direito */}
              {!data.dataDetalheOportunidade?.repasseAssociativo ? (
                <S.ContainerGray>
                  <SelectComponent
                    onChange={(event) => {
                      const selectedItem = dataViasList.find(
                        (item) => item.value === event.target.value
                      );
                      setDataVias(selectedItem);
                      handleGenerate();
                    }}
                    data={dataViasList}
                    value={dataVias?.value || ""}
                    placeholder="Selecione a via do PV"
                    label=""
                    width="200px"
                  />
                  <S.WhiteButton
                    disabled={mutateVias.isLoading || dataVias === null}
                    onClick={() => viewDocumento()}
                  >
                    {mutateVias.isLoading ? (
                      <MaterialUI.CircularProgress
                        size={18}
                        style={{ color: "#2D5BFF" }}
                      />
                    ) : (
                      <IoEye
                        size={18}
                        color={
                          mutateVias.isLoading || dataVias === null
                            ? "#D5DEFF"
                            : "#2D5BFF"
                        }
                      />
                    )}
                  </S.WhiteButton>
                  <S.WhiteButton
                    disabled={mutateVias.isLoading || dataVias === null}
                    onClick={() => downloadDocumento()}
                  >
                    {mutateVias.isLoading ? (
                      <MaterialUI.CircularProgress
                        size={18}
                        style={{ color: "#2D5BFF" }}
                      />
                    ) : (
                      <LiaDownloadSolid
                        size={18}
                        color={
                          mutateVias.isLoading || dataVias === null
                            ? "#D5DEFF"
                            : "#2D5BFF"
                        }
                      />
                    )}
                  </S.WhiteButton>
                </S.ContainerGray>
              ) : null}
            </S.Row>

            {/* Terceira linha - Botões adicionais */}
            <S.Row
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                marginTop: 12,
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              {data?.dataDetalheOportunidade?.vincularLeadProposta ? (
                <S.Button
                  onClick={() => {
                    setOpenModalVincular(true);
                  }}
                  width="120px"
                  height="36px"
                  color="#2D5BFF"
                >
                  <S.TextButton color="#EAEFFF" style={{ gap: "6px" }}>
                    Vincular <IoShareSocial size={14} />
                  </S.TextButton>
                </S.Button>
              ) : null}

              {data?.dataDetalheOportunidade?.propostaManual &&
              data?.dataDetalheOportunidade?.urlPropostaExcel ? (
                <S.Button
                  onClick={() => downloadPropostaExcel()}
                  width="190px"
                  height="36px"
                  color="#E8F5E9"
                  border="1px solid #4CAF50"
                >
                  <S.TextButton color="#2E7D32" style={{ gap: "6px" }}>
                    <RiFileExcel2Fill size={16} color="#4CAF50" />
                    Baixar Proposta (Excel)
                  </S.TextButton>
                </S.Button>
              ) : null}

              {data?.dataDetalheOportunidade?.enviarComprovanteAto ? (
                <S.Button
                  onClick={() => setOpenModalComprovanteAto(true)}
                  width="180px"
                  height="36px"
                >
                  <S.TextButton color="#FFF" style={{ gap: "6px" }}>
                    Enviar Comprovante do Ato <FaRegFileLines size={14} />
                  </S.TextButton>
                </S.Button>
              ) : null}
            </S.Row>

            <S.ContainerLast>
              <S.Row
                style={{
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <S.Button
                  onClick={() =>
                    data.funnelBackPath
                      ? history.push(data.funnelBackPath)
                      : history.goBack()
                  }
                  width="90px"
                  height="36px"
                  color="#ECECEC"
                >
                  <FaArrowLeft size={14} color="#A3A3A6" />
                  <S.TextButton color="#A3A3A6">Voltar</S.TextButton>
                </S.Button>
                <S.Row style={{ gap: "12px", flexWrap: "wrap" }}>
                  {data?.dataDetalheOportunidade?.solicitacaoAjusteVisivel ? (
                    <S.ButtonBordered
                      onClick={() => setOpenModalSolicitarAjuste(true)}
                      width="150px"
                      height="36px"
                      border={"1px solid #2D5BFF"}
                      color={"#FFFFFF"}
                    >
                      <S.TextButton color={"#2D5BFF"}>
                        Solicitar ajuste
                      </S.TextButton>
                    </S.ButtonBordered>
                  ) : null}
                  {data?.dataDetalheOportunidade?.aprovacaoComercialVisivel ? (
                    <S.Button
                      onClick={() => setOpenModalAprovacao(true)}
                      disabled={
                        data?.dataDetalheOportunidade?.ajustarProposta &&
                        data?.dataDetalheOportunidade
                          ?.reenviarAprovacaoComercial
                      }
                      width="180px"
                      height="36px"
                      color="#2D5BFF"
                    >
                      <S.TextButton color="#FFFFFF">
                        {data?.dataDetalheOportunidade
                          ?.reenviarAprovacaoComercial
                          ? "Reenviar para Aprovação comercial"
                          : "Aprovação comercial"}
                      </S.TextButton>
                      <MdKeyboardArrowRight size={18} color="#FFFFFF" />
                    </S.Button>
                  ) : null}
                  {data?.dataDetalheOportunidade?.entradaProcessoVisivel ? (
                    <S.Button
                      onClick={() => setOpenModalEntradaProcesso(true)}
                      width="160px"
                      height="36px"
                      color="#4CAF50"
                    >
                      <S.TextButton color="#FFFFFF">
                        Entrada de Processo
                      </S.TextButton>
                      <MdKeyboardArrowRight size={18} color="#FFFFFF" />
                    </S.Button>
                  ) : null}
                </S.Row>
              </S.Row>
            </S.ContainerLast>
          </>
        )}
      </S.Container>
      <ModalCommon
        open={openModalAprovacao}
        setOpenModal={setOpenModalAprovacao}
        onClose={() => {
          setOpenModalAprovacao(false);
        }}
      >
        <ModalAprovacao
          onClose={() => {
            setOpenModalAprovacao(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalEntradaProcesso}
        setOpenModal={setOpenModalEntradaProcesso}
        onClose={() => {
          setOpenModalEntradaProcesso(false);
        }}
      >
        <ModalEntradaProcesso
          onClose={() => {
            setOpenModalEntradaProcesso(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalLaudo}
        setOpenModal={setOpenModalLaudo}
        onClose={() => {
          setOpenModalLaudo(false);
        }}
      >
        <ModalAnexarLaudoVivaz
          onClose={() => {
            setOpenModalLaudo(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalComprovanteAto}
        setOpenModal={setOpenModalComprovanteAto}
        onClose={() => {
          setOpenModalComprovanteAto(false);
        }}
      >
        <ModalComprovanteAto
          onClose={() => {
            setOpenModalComprovanteAto(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalResultadoAnalise}
        setOpenModal={setOpenModalResultadoAnalise}
        onClose={() => {
          setOpenModalResultadoAnalise(false);
        }}
      >
        <ModalResultadoAnalise
          onClose={() => {
            setOpenModalResultadoAnalise(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalSolicitarAjuste}
        setOpenModal={setOpenModalSolicitarAjuste}
        onClose={() => {
          setOpenModalSolicitarAjuste(false);
        }}
      >
        <ModalSolicitarAjuste
          onClose={() => {
            setOpenModalSolicitarAjuste(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalTransferirProposta}
        setOpenModal={setOpenModalTransferirProposta}
        onClose={() => {
          setOpenModalTransferirProposta(false);
        }}
      >
        <ModalTransferirProposta
          onClose={() => {
            setOpenModalTransferirProposta(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalCompartilhar}
        setOpenModal={setOpenModalCompartilhar}
        onClose={() => {
          setOpenModalCompartilhar(false);
        }}
      >
        <ModalCompartilhar
          onClose={() => {
            setOpenModalCompartilhar(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
      <ModalCommon
        open={openModalVincular}
        setOpenModal={setOpenModalVincular}
        onClose={() => {
          setOpenModalVincular(false);
        }}
      >
        <ModalVincular
          onClose={() => {
            setOpenModalVincular(false);
          }}
          dataDetalheOportunidade={data.dataDetalheOportunidade}
          refetchDetalheOportunidade={data.refetchDetalheOportunidade}
          refetchHistorico={data.refetchHistorico}
        />
      </ModalCommon>
    </>
  );
}
